export const canister_sonic_swap = "3xwpq-ziaaa-aaaah-qcn4a-cai";
export const canister_wicp =  "utozz-siaaa-aaaam-qaaxq-cai";
export const canister_xtc = "aanaa-xaaaa-aaaah-aaeiq-cai";
export const canister_ii = "4k2wq-cqaaa-aaaab-qac7q-cai";
//cmc
export const canister_cycles_minting = "rkp4c-7iaaa-aaaaa-aaaca-cai";
//ledger
export const canister_nns_ledger = "ryjl3-tyaaa-aaaaa-aaaba-cai";
//difi
export const canister_dbs = "trejq-eyaaa-aaaah-abjzq-cai";
//ic
export const canister_admin = "mxjrx-tiaaa-aaaah-aaoxq-cai";
export const canister_wasm_storage = "n2hvz-4aaaa-aaaah-aaoqa-cai";
export const canister_dbs_token = "tedy5-fqaaa-aaaah-abj2a-cai";
export const canister_dbs_token_test = "vgjfw-jiaaa-aaaah-abjmq-cai";
